var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-tint-embed" }, [
    _vm.isReady
      ? _c("div", [
          _c("div", {
            staticClass: "tintup",
            staticStyle: { height: "500px", width: "100%" },
            attrs: {
              "data-id": _vm.tintId,
              "data-columns": _vm.columnCount,
              "data-count": _vm.count,
              "data-query": _vm.query,
              "data-personalization-id": _vm.personalizationId,
              "data-expand": "true",
              "data-paginate": "true",
            },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }